import { Component, Input } from '@angular/core';
import { LeaderFormComponent } from './leader-form.component';
import { StakeLeader, ChurchUnitsDataService, UnitLeader } from '../../shared';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-stake-leader-form',
  templateUrl: './leader-form.component.html',
  styleUrls: ['./leader-form.component.scss']
})
export class StakeLeaderFormComponent extends LeaderFormComponent {
  @Input() leader: StakeLeader;

  constructor(protected formBuilder: FormBuilder, protected churchService: ChurchUnitsDataService, protected dialog: MatDialog) {
    super(formBuilder, dialog);
  }

  /**
   * Indicates if our stake leader is brand new (never saved before).
   */
  isNewLeader() {
    return !(this.leader.campusStakeOfficeId > 0);
  }

  /**
   * Updates the stake leader's information on the server.
   *
   * @param leaderToSave The stake leader's information to save
   * @param newPhoto The leader's new photo, if any
   * @param deletePhoto Whether or not we want to delete the leader's current photo
   */
  protected saveLeader(unitLeader: UnitLeader, newPhoto: File, deletePhoto: boolean) {
    this.workedMessage = null;
    this.workingMessage = 'Saving information';

    // we need properties from the stake leader (like campus stake id, position type) but then override the others with what is coming in to actually be saved.
    const stakeLeader = Object.assign({}, this.leader, unitLeader);

    let observable: Observable<StakeLeader>;
    if (this.isNewLeader()) {
      observable = this.churchService.createStakeLeader(stakeLeader, newPhoto);
    } else {
      observable = this.churchService.updateStakeLeader(stakeLeader, newPhoto, this.deletePhoto);
    }

    observable
      .pipe(
        finalize(() => (this.workingMessage = null))
      )
      .subscribe(
        updatedLeader => {
          this.onSaved(updatedLeader);
        },
        error => {
          this.showError(error);
        }
      );
  }

  /**
   * Deletes the leader's information.  When deleted, creates a new empty leader so that it can immediately be updated.
   */
  protected deleteLeader() {
    this.workedMessage = null;
    this.workingMessage = 'Removing leader';

    // need to remember what position and ward this was for so we can new up a new one when it deletes
    const campusStakeId = this.leader.campusStakeId;
    const position = this.leader.positionType;
    this.churchService
      .deleteStakeLeader(this.leader)
      .pipe(
        finalize(() => (this.workingMessage = null))
      )
      .subscribe(
        () => {
          this.onDeleted(new StakeLeader(position, campusStakeId));
        },
        error => {
          this.showError(error);
        }
      );
  }
}
